module.exports = __webpack_public_path__ + "img/Sainaposter.20067c85.png";